// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"25e48765","453":"46504868","464":"8c7b3ae4"}[chunkId] + ".chunk.js";
};